import { MdBlock } from 'react-icons/md';
import { useI18n } from 'contexts/i18n';
import * as Styled from './DSOStoreDisabledMessage.styles';

type DSOStoreDisabledMessageProps = {
  isError?: boolean;
};

const DSOStoreDisabledMessage = ({
  isError = false,
}: DSOStoreDisabledMessageProps) => {
  const i18n = useI18n();
  return (
    <Styled.Container>
      <Styled.IconWrapper>
        <MdBlock size={48} />
      </Styled.IconWrapper>
      <Styled.Title>
        {isError
          ? i18n['Unable to verify permissions.'] ||
            'Unable to verify permissions.'
          : i18n['Unauthorized Access.'] || 'Unauthorized access.'}
      </Styled.Title>
      <Styled.Message>
        {isError
          ? i18n[
              'We could not verify your permissions. Please try again later.'
            ] || 'We could not verify your permissions. Please try again later.'
          : i18n['You are not authorized to access this portal.'] ||
            'You are not authorized to access this portal.'}
      </Styled.Message>
    </Styled.Container>
  );
};

export default DSOStoreDisabledMessage;
